export default __webpack_public_path__ + "media/plus/transfer-without-limit-08a3d913.svg";